module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Cutting board-07924f982cd750c96cacba668864159b.svg";